// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewReservation-capitalize-_byzh {
	text-transform: capitalize;
}

.ViewReservation-titleText-seHux {
	font-size: 24px;
	line-height: 32px;
	margin: 0;
}

.ViewReservation-secondaryTextColor-L5O67 {
	color: var(--secondary-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/ViewReservation/ViewReservation.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,kCAAkC;AACnC","sourcesContent":[".capitalize {\n\ttext-transform: capitalize;\n}\n\n.titleText {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tmargin: 0;\n}\n\n.secondaryTextColor {\n\tcolor: var(--secondary-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"capitalize": `ViewReservation-capitalize-_byzh`,
	"titleText": `ViewReservation-titleText-seHux`,
	"secondaryTextColor": `ViewReservation-secondaryTextColor-L5O67`
};
module.exports = ___CSS_LOADER_EXPORT___;
